import React, { Component } from "react";
import { connect } from "react-redux";
import {
  WithStyles,
  withStyles,
  Button,
  Grid,
  Typography,
  Checkbox,
  FormControlLabel,
  Radio,
  createStyles,
  Theme,
  Menu,
  MenuItem,
  Link,
  ClickAwayListener,
} from "@material-ui/core";
import { Error } from "@material-ui/icons";

import { MyPATDialog, MyPATIconButton } from "../../common";

import { bindActionCreators } from "redux";
import * as XLSX from "xlsx";

import {
  getCourseList,
  setBulkImportTest,
} from "../../userManagement/actions/userActions";
import contentManagementService from "../service/courseManagementServices";
import * as courseManagementActions from "../actions/courseManagementActions";
import cx from "classnames";
import moment from "moment";


import _ from "lodash";
import { AnyRecord } from "dns";
import MyPATUploader, { Attachment } from "../../common/MyPATUploader";
import MyPATUploadPreview, {
  convertFileOrUrlToPreviewItem,
} from "../../common/MyPATUploadPreview";
import DropZone from "../../common/DropZone";
import { BULK_IMPORT_SAMPLE_FILE } from "../Constants/constants";
import {
  CloseOutlined as CloseIcon,
} from '@material-ui/icons';

import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { debounce } from "../../../utils";

const styles = (theme: Theme) =>
  createStyles({
    menuItem: {
      borderStyle: "solid",
      borderBottomWidth: 1,
      borderColor: theme.palette.grey[300],
      padding: 0,
      height: "auto",
      minWidth: "170px",
      "&:last-child": {
        borderBottomWidth: 0,
      },
      "& a": {
        paddingTop: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        paddingRight: theme.spacing.unit * 2,
        paddingLeft: theme.spacing.unit * 2,
        width: "100%",
      },
      "& img, & p": {
        display: "inline-block",
        verticalAlign: "middle",
        fontSize: 14,
        lineHeight: "19px",
        color: "#333333",
      },
    },
    bulkTitle: {
      fontSize: 20,
      fontWeight: "normal",
      margin: 0,
    },
    orDevider: {
      position: "relative",
      marginBottom: 50,
      alignItems: 'center',
      marginTop: 10,
      "&::before": {
        top: "50%",
        left: "47%",
        content: '"OR"',
        position: "absolute",
        width: "30px",
        height: "30px",
        backgroundColor: "#e5edf5",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1,
        transform: "translate(0%, -50%)",
        borderRadius: "50%",
        fontWeight: 400,
        fontSize: 12,
        color: '#666',
        fontStyle: 'italic',
      },
      "&::after": {
        left: "50%",
        content: '" "',
        position: "absolute",
        border: "1px solid #e4e4e4",
        height: "100%",
      },
      "& button": {
        margin: "10px 0",
      },
    },
    paddingLeft: {
      paddingLeft: 40,
    },

    paddingRight: {
      paddingRight: 40,
    },
    disabled: {
      opacity: 0.5,
      cursor: "default",
      pointerEvents: "none",
    },
    optionContainer: {
      marginTop: 10,
      position: 'relative',
      "& input": {
        border: "1px solid #DFDFDF",
        width: "100%",
        padding: "10px",
        borderRadius: 4,
        background: 'none',
        height: 45,
        lineHeight: '45px',
        cursor: 'pointer',
        paddingRight: 70,
        textOverflow: 'ellipsis',
        fontSize: 14,
      },
    },
    optionContainerEdit:{
      "& input": {
        paddingRight: 70,
    },
    },
    optionlistContainer: {
      position: "relative",
      '&:hover':{
        cursor: 'pointer',
      },
      "&::after": {
        top: "5px",
        right: "18px",
        border: "solid rgb(0 0 0 / 0%)",
        height: 0,
        content: '" "',
        zIndex: 999,
        position: "absolute",
        transform: "rotate(226deg)",
        boxShadow: "1px 1px 1px #DFDFDF",
        background: "rgb(255 255 255)",
        borderColor: "rgb(194 225 245 / 0%)",
        borderWidth: 9,
        borderBottomColor: "rgb(255 255 255)",
      },
    },
    optionList: {
      width: "100%",
      border: "1px solid #DFDFDF",
      display: "block",
      position: "absolute",
      backgroundColor: "#fff",
      top: "13px",
      borderRadius: "7px",
      maxHeight: 250,
      overflowX: "hidden",
      overflowY: "auto",
      zIndex: 2,
      "& input": {
        marginTop: 15,
        paddingLeft: 40,
      },
      "& span": {
        display: "block",
        padding: '1px 0px 2px 10px',
        cursor: 'pointer',
      },

      // top: "-16px",
      // right: "15px",
      // width: 0,
      // height: 0,
      // content: '" "',
      // position: "absolute",
      // marginLeft: "-20px",
      // borderLeft: "10px solid transparent",
      // borderRight: "10px solid transparent",
      // borderBottom: "15px solid #dadada",
      // borderTopLeftRadius: "20px",
      // borderTopRightRadius: "0px",
      // }
    },
    optionListEdit:{
      "& span": {
        padding: '10px 15px',
        borderBottom: '1px solid #eee',
      }
    },
    searchContainer: {
      position: "sticky",
      top: 0,
      zIndex: 1,
      backgroundColor: '#fff',
      paddingBottom: 15,
      borderBottom: '1px solid #e6e6e6',
      marginBottom: 10,
      paddingLeft: 15,
      paddingRight: 15,
      "& img": {
        left: 29,
        position: "absolute",
        top: 29,
      },
    },
    padding2x:{
      padding: '10px 0',
    },
    courseTitle:{
      fontSize: 18,
      fontWeight: 600,
      color: '#666',
    },
    plusCourse:{
      position: 'relative',
      '& span':{
        position: 'absolute',
        right: 0,
        top: 8,
        color: '#1d7dea',
        width: 30,
        height: 30,
        backgroundColor: '#e8f2fd',
        borderRadius: '50%',
        fontSize: 13,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontWeight: 'bold',
        marginRight: 40,
      }
    },
    plusCourseEdit:{
      position: 'relative',
      '& span':{
        top: 3,
        color: '#1d7dea',
        width: 40,
        height: 40,
        fontSize: 12,
        position: 'absolute',
        right: 0,
        backgroundColor: '#e8f2fd',
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontWeight: 'bold',
        marginRight: 40,
      }
    },
    fileInfo: {
      fontSize: 12,
      lineHeight: "16px",
      color: "#999",
      display: "block",
      fontWeight: "normal",
    },
    uploadPreview: {
      "&>:first-child": {
        '&>div:nth-of-type(1)':{
          maxWidth: '100%',
          flexBasis: '100%',
        },
        justifyContent: "center",
        "&>:first-child": {
          "&>:first-child": {
            margin: "16px 0",
          },
        },
      },
    },
    textCenter:{
      textAlign: 'center',
    },
    noBorder:{
      borderBottom: 0,
    },
    iconRoot: {
      fill: theme.palette.text.secondary,
      // opacity: 0.5,
      margin: 0,
      width: '2rem',
      height: '2rem',
    },
    buttonCloseCont:{
      position: 'relative',
      height: 20,
      '& button':{
        position: 'absolute',
        right: '-15px',
        top: '-35px',
        border: 'none',
      }
    },
    arrowIcon:{
      position: 'absolute',
      right: 10,
      top: 12,
      transform: 'scale(1.3)',
      zIndex: 1,
      width: 20,
      height: 20,
      backgroundColor: '#fff',
      '& img':{
        // opacity: .3,
        width: 16,
      }
    },
  });
interface BulkImportTestProps extends WithStyles<typeof styles> {
  classes: any;
  courseList: any[];
  getCourseList: Function;
  setBulkImportTest: Function;
  fetchExistingScheduledTests: Function;
  openBulkImport: boolean;
  closeBulkImport: Function;
  redirectToBulkImport: Function;
}

interface BulkImportTestState {
  showCourseDropdown: boolean;
  filteredCourseList: any[];
  selectedCourse: any[];
  showSingleCourseDropdown: boolean;
  filteredSingleCourseList: any[];
  selectedSingleCourse: any;
  isCourseAllSelect: boolean;
  showTestDropdown: boolean;
  filteredTestList: any[];
  selectedTest: any[];
  isTestAllSelect: boolean;
  scheduledTestList: any[];
  openDialog: boolean;
  openConfirmationPopup: boolean;
  attachments: Attachment[];
  payload: any;
  showItems: number;

}
const ALLOWED_ORDER_NOTE_ATTACHMENTS = [
  "xls",
  "xlsx",
  "csv",
  "vnd.ms-excel",
  "x-csv",
  "plain",
  "vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "vnd.openxmlformats-officedocument.wordprocessingml.document",
];
class BulkImportTest extends Component<
  BulkImportTestProps,
  BulkImportTestState
> {
  upload: any = null;

  constructor(props: BulkImportTestProps) {
    super(props);
    this.state = {
      showCourseDropdown: false,
      filteredCourseList: [],
      selectedCourse: [],
      showSingleCourseDropdown: false,
      filteredSingleCourseList: [],
      selectedSingleCourse: {},
      isCourseAllSelect: false,
      showTestDropdown: false,
      filteredTestList: [],
      selectedTest: [],
      isTestAllSelect: false,
      scheduledTestList: [],
      openDialog: false,
      openConfirmationPopup: false,
      attachments: [],
      payload: {
        sourcePackageId: '',
        destinationSkus: [],
        tests: []
      },
      showItems: 10
    };
    this.toggleTestDropdown = debounce(this.toggleTestDropdown, 100);
    this.increaseList = this.increaseList.bind(this);
    this.toggleShowCourseDropdown = debounce(this.toggleShowCourseDropdown, 100);
    this.toggleSingleCourseDropdown = debounce(this.toggleSingleCourseDropdown, 100);
    this.getCourseSuggestions = _.debounce(this.getCourseSuggestions, 200);
    this.getTestSuggestions = _.debounce(this.getTestSuggestions, 200);
    this.getSingleCourseSuggestions = _.debounce(
      this.getSingleCourseSuggestions,
      200
    );
  }

  static getDerivedStateFromProps(nextProps: any, prevState: any) {
    if (nextProps.openBulkImport != prevState.openDialog) {
      return {
        openDialog: nextProps.openBulkImport,
      };
    } else return null;
  }
  toggleDialog() {
    this.setState({ openDialog: false, selectedTest: [], selectedCourse: [], selectedSingleCourse: {}, attachments: [], payload: {
      sourcePackageId: '',
      destinationSkus: [],
      tests: []
    } });
    this.props.closeBulkImport();
  }
  componentDidMount() {
    this.props.getCourseList({pagination:false});
  }
  setAttachments = (attachments: Attachment[]) => {
    this.setState({
      attachments,
    });
    if(attachments.length > 0) {
      this.handleFile(attachments);

    } else {
      this.setState((prevState) => ({
        ...prevState,
        payload: { ...prevState.payload, destinationSkus: [] },
      }));
    }
  };
  handleCourseChange = (event: any) => {
    let subjectID = event.target.value;
    let isChecked = event.target.checked;
    let { isCourseAllSelect, selectedCourse, filteredCourseList } = this.state;
    let newSelectedSubjects = [...selectedCourse];

    if (isChecked) {
      if (subjectID === "SelectAll") {
        newSelectedSubjects = [];
        isCourseAllSelect = true;
        filteredCourseList.forEach((sub) => {
         if(!sub.isUpdateLocked){ 
            newSelectedSubjects.push(sub._id);
          }
        });
      } else {
        newSelectedSubjects.push(subjectID);
        isCourseAllSelect = false;
      }
    } else {
      if (subjectID === "SelectAll") {
        newSelectedSubjects = [];
      } else {
        let indx = newSelectedSubjects.indexOf(subjectID);
        newSelectedSubjects.splice(indx, 1);
      }
      isCourseAllSelect = false;
    }
    if(newSelectedSubjects.length === filteredCourseList.length) {
      isCourseAllSelect = true;
    }
    this.setState({ selectedCourse: newSelectedSubjects, isCourseAllSelect });
  };

  handleTestChange = (event: any) => {
    let subjectID = event.target.value;
    let isChecked = event.target.checked;
    let { isTestAllSelect, selectedTest, filteredTestList } = this.state;
    let newSelectedSubjects = [...selectedTest];

    if (isChecked) {
      if (subjectID === "SelectAll") {
        newSelectedSubjects = [];
        isTestAllSelect = true;
        filteredTestList.forEach((sub) => {
          newSelectedSubjects.push(sub._id);
        });
      } else {
        newSelectedSubjects.push(subjectID);
        isTestAllSelect = false;
      }
    } else {
      if (subjectID === "SelectAll") {
        newSelectedSubjects = [];
      } else {
        let indx = newSelectedSubjects.indexOf(subjectID);
        newSelectedSubjects.splice(indx, 1);
      }
      isTestAllSelect = false;
    }
    if(newSelectedSubjects.length === filteredTestList.length) {
      isTestAllSelect = true;
    }
    this.setState({ selectedTest: newSelectedSubjects, isTestAllSelect });
  };

  handleSingleCourseChange = (
    id: string,
    name: string,
    coursePlanId: string
  ) => {
    let newSelectedSubjects = { id, name };
    this.setState({
      selectedSingleCourse: newSelectedSubjects,
      showSingleCourseDropdown: false,
      selectedTest: []
    });
    this.getScheduledTests(coursePlanId);
  };
  getScheduledTests = async (courseId: string) => {
    const response = await contentManagementService.fetchExistingScheduledTests(
      courseId
    );
    response.map((ele: any) => {
      if(ele.startDate) {
        const initiateDate = moment(ele.startDate).format('DD MMM YYYY');
        const initiateTime = moment(ele.startDate).format('hh:mm A');
        ele.name = ele.name + ' | ' + initiateDate + ' ' +  initiateTime;
      }
      return ele
    })
    this.setState({ scheduledTestList: response });
  };
  getCourseSuggestions(value: string) {
    const { courseList } = this.props;
    const { selectedSingleCourse } = this.state;

    value = value.toString();
    value = value.replace(/[{()}]/g, '');
    value = value.replace(/\\|\//g,'')


    this.setState((prevState) => {
      let suggestions: any = [];
      if (value.length > 0) {
        value = value.toLowerCase();

        for (let indx = 0; indx < courseList.length; indx++) {
          let ug = courseList[indx];
          if (ug.name && ug.name.replace(/[{()}]/g, '').replace(/\\|\//g,'').toLocaleLowerCase().search(value) != -1) {
            suggestions.push(ug);
          }
        }
      } else {
        suggestions = [...courseList];
      }
      suggestions = suggestions.filter((ele: any) => ele._id !== selectedSingleCourse.id)
      return { filteredCourseList: suggestions, showItems: 10 };
    });
  }

  getTestSuggestions(value: string) {
    const { scheduledTestList } = this.state;
    value = value.toString();
    value = value.replace(/[{()}]/g, '');
    value = value.replace(/\\|\//g,'')


    this.setState((prevState) => {
      let suggestions: any = [];
      if (value.length > 0) {
        value = value.toLowerCase();

        for (let indx = 0; indx < scheduledTestList.length; indx++) {
          let ug = scheduledTestList[indx];
          if (ug.name && ug.name.replace(/[{()}]/g, '').replace(/\\|\//g,'').toLocaleLowerCase().search(value) != -1) {
            suggestions.push(ug);
          }
        }
      } else {
        suggestions = [...scheduledTestList];
      }
      return { filteredTestList: suggestions };
    });
  }
  getSingleCourseSuggestions(value: string) {
    const { courseList } = this.props;

    this.setState((prevState) => {
      let suggestions: any = [];
      value = value.toString();
      value = value.replace(/[{()}]/g, '');
      value = value.replace(/\\|\//g,'')

      if (value.length > 0) {
        value = value.toLowerCase();

        for (let indx = 0; indx < courseList.length; indx++) {
          let ug = courseList[indx];
          if (ug.name && ug.name.replace(/[{()}]/g, '').replace(/\\|\//g,'').toLocaleLowerCase().search(value) != -1) {
            suggestions.push(ug);
          }
        }
      } else {
        suggestions = [...courseList];
      }
      return { filteredSingleCourseList: suggestions };
    });
  }

  renderer = () => {
    const { courseList } = this.props;
    const { selectedCourse } = this.state;
    if (courseList && courseList.length > 0) {
      let list: any[] = JSON.parse(JSON.stringify(courseList));
      return (
        list &&
        list
          .reduce((acc: string[], { _id, name }) => {
            if (selectedCourse.includes(_id)) {
              acc.push(name);
            }
            return acc;
          }, []).splice(0, 1)
          .join(", ")
      );
    } else {
      return [];
    }
  };
  testRenderer = () => {
    const { selectedTest, scheduledTestList } = this.state;
    if (scheduledTestList && scheduledTestList.length > 0) {
      let list: any[] = JSON.parse(JSON.stringify(scheduledTestList));
      return (
        list &&
        list
          .reduce((acc: string[], { _id, name }) => {
            if (selectedTest.includes(_id)) {
              if(name.includes('|')) {
                acc.push(name.split('|')[0])
              } else {
                acc.push(name);
              }
            }
            return acc;
          }, []).splice(0, 3)
          .join(", ")
      );
    } else {
      return [];
    }
  };

  openConfirmationDialog() {
    this.setState({openConfirmationPopup: true})
  }

  closeConfirmationDialog() {
    this.setState({openConfirmationPopup: false})
  }

  handleFile = (Files: Attachment[]) => {
    this.readExcel(Files[0]);
    
  };

  handleDownloadClick = () => {
    const url: string = BULK_IMPORT_SAMPLE_FILE;
    window.open(url, "_blank");
  };

  readExcel = (file: any) => {
    let destinationSkus: any[];
    const promise = new Promise((resolve: any, reject: any) => {
      const fileReader = new FileReader();
      if(file.type !== "text/csv") { 
        fileReader.readAsArrayBuffer(file);

      } else {
        fileReader.readAsText(file);

      }

      fileReader.onload = (e: any) => {
        const bufferArray = e.target.result;

        const wb = XLSX.read(bufferArray, { type: "buffer" });

        const wsname = wb.SheetNames[0];

        const ws = wb.Sheets[wsname];

        const data = XLSX.utils.sheet_to_json(ws);

        resolve(data); 

        fileReader.onerror = (error) => {
          reject(error);
        };

      };
    });

    promise.then((d: any) => {
      destinationSkus = d && d.map( (sku: any) => sku.SKU);
      this.setState((prevState) => ({
        ...prevState,
        payload: { ...prevState.payload, destinationSkus },
      }));

     });
  }
  
    bulkImportProcess() {
    let payload: any = JSON.parse(JSON.stringify(this.state.payload))
    payload.sourcePackageId = this.state.selectedSingleCourse.id;
    if(this.state.selectedCourse.length > 0) {
      let destinationSKU = this.props.courseList.filter((ele) =>
      this.state.selectedCourse.includes(ele._id)
    );
    destinationSKU = destinationSKU.map((ele) => ele.sku);
    payload.destinationSkus = destinationSKU;
    }
    let selectedTests: any[];
    selectedTests = this.state.scheduledTestList.filter((ele) =>
      this.state.selectedTest.includes(ele._id)
    );
    selectedTests.forEach((ele: any) => {
      let test = {
        testId: ele.testId,
        courseId: ele.courseId,
        scheduleID: ele.scheduleID,
      };
      payload.tests.push(test);
    });

    this.props.setBulkImportTest(payload);
    this.setState({openConfirmationPopup: false, openDialog: false, selectedTest: [], selectedCourse: [], selectedSingleCourse: {}, attachments: [], payload: {
      sourcePackageId: '',
      destinationSkus: [],
      tests: []
    }})
    this.props.closeBulkImport();
    setTimeout(() => {
      this.props.redirectToBulkImport();
 
    }, 50)
  }

  toggleShowCourseDropdown = () => {
    const { showCourseDropdown } = this.state;
    let list = this.props.courseList.filter( (ele) => ele._id !== this.state.selectedSingleCourse.id);
    this.setState({ showCourseDropdown: !showCourseDropdown, filteredCourseList: [...list], showItems: 10});
  }

  increaseList() {
    this.setState((prevState) => ({
      ...prevState,
      showItems: ((prevState.showItems + 10) > this.props.courseList.length) ?  this.props.courseList.length : prevState.showItems + 10
    }));

  }
  toggleTestDropdown = () => {
    const { showTestDropdown } = this.state;
    this.setState({ showTestDropdown: !showTestDropdown, filteredTestList: [...this.state.scheduledTestList]});
  }

  toggleSingleCourseDropdown = () => {
    const { showSingleCourseDropdown } = this.state;
    this.setState({ showSingleCourseDropdown: !showSingleCourseDropdown, filteredSingleCourseList: [...this.props.courseList]});
  }

  render() {
    const { classes, courseList } = this.props;
    const {
      showCourseDropdown,
      filteredCourseList,
      isCourseAllSelect,
      selectedCourse,
      showSingleCourseDropdown,
      filteredSingleCourseList,
      selectedSingleCourse,
      filteredTestList,
      selectedTest,
      showTestDropdown,
      isTestAllSelect,
      scheduledTestList,
      openDialog,
      openConfirmationPopup,
      attachments,
      payload
    } = this.state;

    return (
      <>
        <MyPATDialog
          isApplyCustom
          isfixedDialogActions
          dialogOpen={openDialog}
          dialogHasActions={true}
          dialogHeading={
            <>
              <h3 className={classes.bulkTitle}>
                {" "}
                Import Scheduled tests
              </h3>
            </>
          }
          isAlignCenter={true}
          customButtonVariant="withoutBorderCloseIcon"
          onDialogClose={() => this.toggleDialog()}
          isCustomBackground={false}
          isborderDialogAction={true}
          otherDialogProps={{
            fullWidth: false,
          }}
          customDialogActions={
            <>
            <Grid container justify="center">
            <Grid item>
              <Button
                disabled={!((this.state.payload.destinationSkus.length > 0 || selectedCourse.length > 0) && selectedTest.length > 0 && selectedSingleCourse.id) }
                variant="contained"
                color="primary"
                onClick={() => {
                  this.openConfirmationDialog();
                }}
              >
                Bulk Import
              </Button>
            </Grid>
          </Grid>
            </>
          }
        >
          <Grid container>
            <Grid item xs={12} className={classes.padding2x}>
              <Typography variant="h4" className={classes.courseTitle}>Select A Course</Typography>
              <div className={classes.optionContainer}>
                <div
                  onClick={this.toggleSingleCourseDropdown}
                >
                  <input
                    type="text"
                    placeholder="Select A Course"
                    value={selectedSingleCourse.name}
                  />
                  <Grid className={classes.arrowIcon}>
                  {/* <KeyboardArrowDownIcon /> */}
                  <img src="/assets/svg/dropdown-arrow.svg" />
                  </Grid>
                </div>
                {showSingleCourseDropdown && (
                <ClickAwayListener onClickAway={this.toggleSingleCourseDropdown}>

                  <div className={classes.optionlistContainer}>
                    <div className={[classes.optionList, classes.optionListEdit].join(' ')}>
                      <div className={classes.searchContainer}>
                        <input
                          type="text"
                          placeholder="Search Course Name or Course SKU"
                          onChange={(event) => {
                            this.getSingleCourseSuggestions(event.target.value);
                          }}
                        />
                        <img src="/assets/svg/userManagement/search-icon.svg" />
                      </div>
                      {(filteredSingleCourseList || []).map(
                        ({ _id, name, coursePlanId }) => (
                          <span
                            key={_id}
                            onClick={() =>
                              this.handleSingleCourseChange(
                                _id,
                                name,
                                coursePlanId
                              )
                            }
                          >
                            {name}
                          </span>
                        )
                      )}
                    </div>
                  </div>
                  </ClickAwayListener>
                )}
              </div>
            </Grid>
            <Grid item xs={12} className={classes.padding2x}>
              <Typography variant="h4" className={classes.courseTitle}>Select Scheduled Tests</Typography>
              <div className={classes.optionContainer}>
                <div
                  className={cx(
                    classes.plusCourse,
                    !selectedSingleCourse.name ? classes.disabled : ""
                  )}
                  onClick={this.toggleTestDropdown}
                >
                  <input
                    type="text"
                    placeholder="Select Scheduled Tests"
                    value={this.testRenderer()}
                  />
                  {selectedTest.length > 3 && (
                    <span>+{selectedTest.length - 3}</span>
                  )}
                  <Grid className={classes.arrowIcon}>
                  {/* <KeyboardArrowDownIcon /> */}
                  <img src="/assets/svg/dropdown-arrow.svg" />
                  </Grid>
                </div>

                {showTestDropdown && (
                <ClickAwayListener onClickAway={this.toggleTestDropdown}>

                  <div className={classes.optionlistContainer}>
                    <div className={classes.optionList}>
                      <div className={classes.searchContainer}>
                        <input
                          type="text"
                          placeholder="Search Test ID or Test Name"
                          onChange={(event) => {
                            this.getTestSuggestions(event.target.value);
                          }}
                        />
                        <img src="/assets/svg/userManagement/search-icon.svg" />
                      </div>
                     {filteredTestList.length > 0 && <span>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={
                                isTestAllSelect &&
                                filteredTestList.length == selectedTest.length
                              }
                              onChange={this.handleTestChange}
                              name="Select All"
                              color="primary"
                            />
                          }
                          label="Select All"
                          value="SelectAll"
                          key="select_all_test"
                        />
                      </span> }
                      {(filteredTestList || []).map(({ _id, name }) => (
                        <span>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={selectedTest.includes(_id)}
                                onChange={this.handleTestChange}
                                name="checkedB"
                                color="primary"
                              />
                            }
                            label={name}
                            key={_id}
                            value={_id}
                          />
                        </span>
                      ))}
                    </div>
                  </div>
                  </ClickAwayListener>

                )}
              </div>
            </Grid>
            <Grid container className={classes.orDevider}>
            <Grid item xs={6} className={classes.paddingRight}>
              <Typography variant="h4" className={classes.courseTitle}>Select Destination Course</Typography>
              <div className={[classes.optionContainer, classes.optionContainerEdit].join(' ')}>
                <div
                  className={cx(
                    classes.plusCourseEdit,
                    (attachments.length > 0 || !selectedSingleCourse.name)  ? classes.disabled : ""
                  )}
                  onClick={this.toggleShowCourseDropdown}
                >
                  <input
                    type="text"
                    placeholder="Select Destination Course(s)"
                    value={this.renderer()}
                  />
                  {selectedCourse.length > 1 && (
                    <span>+{selectedCourse.length - 1}</span>
                  )}
                <Grid className={classes.arrowIcon}>
                  {/* <KeyboardArrowDownIcon /> */}
                  <img src="/assets/svg/dropdown-arrow.svg" />
                </Grid>
                </div>

                {showCourseDropdown && (
                <ClickAwayListener onClickAway={this.toggleShowCourseDropdown}>

                  <div className={classes.optionlistContainer}>
                    <div className={classes.optionList} 
                    onScroll={(e: any) => this.increaseList()}
                    >
                      <div className={classes.searchContainer}>
                        <input
                          type="text"
                          placeholder="Search Destination Course"
                          onChange={(event) => {
                            this.getCourseSuggestions(event.target.value);
                          }}
                        />
                        <img src="/assets/svg/userManagement/search-icon.svg" />
                      </div>
                      {filteredCourseList.length > 0 && <span>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={
                                isCourseAllSelect &&
                                filteredCourseList.length ==
                                  selectedCourse.length
                              }
                              onChange={this.handleCourseChange}
                              name="Select All"
                              color="primary"
                            />
                          }
                          label="Select All"
                          value="SelectAll"
                          key="select_all_course"

                        />
                      </span>}
                      {(filteredCourseList || []).slice(0, this.state.showItems).map(({ _id, name,isUpdateLocked}) => (
                        <span>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={selectedCourse.includes(_id)}
                                onChange={this.handleCourseChange}
                                name="checkedB"
                                color="primary"
                                disabled={isUpdateLocked}
                              />
                            }
                            label={name}
                            key={_id}
                            value={_id}
                          />
                        </span>
                      ))}
                    </div>
                  </div>
                  </ClickAwayListener>

                )}
              </div>
            </Grid>

            <Grid
              item
              xs={6}
              className={cx(
                classes.paddingLeft,
                classes.textCenter,
                selectedCourse.length > 0 ? classes.disabled : ""
              )}
            >
              <Typography>Upload list of courses</Typography>
              <MyPATUploader
                  onChange={this.setAttachments}
                  allowedFileTypes={ALLOWED_ORDER_NOTE_ATTACHMENTS}
                  initialAttachments={attachments}
                >
                  {({
                    onItemRemove,
                    attachments,
                    loading,
                    errorMsg,
                    error,
                    handleFileChange,
                  }) => {
                    const list = attachments.map((attachment) =>
                      convertFileOrUrlToPreviewItem(attachment)
                    );
                    return (
                      <>
                          {attachments.length > 0 ? (
                          <Grid className={classes.uploadPreview}>
                            <MyPATUploadPreview
                              list={list}
                              readOnly={false}
                              onItemRemove={onItemRemove}
                            />

                            {error && (
                              <Grid item xs={12} justify="center">
                                <Typography
                                  className={classes.errorText}
                                  variant="caption"
                                  color="error"
                                >
                                  <Error />
                                  {errorMsg}
                                </Typography>
                              </Grid>
                            )}
                          </Grid>
                   ) : (
                      <DropZone onChange={handleFileChange}>
                      <Grid container justify="center">
                        <div className={classes.dragDropVideoContainer}>
                          <Grid container justify="center">
                            <div style={{ width: "100%" }}>
                              <img
                                alt="Cancel video upload"
                                src="/assets/svg/learn/cloudUpload.svg"
                                onClick={(e) => {
                                  this.upload.value = "";
                                  this.upload.click();
                                }}
                                style={{ cursor: "pointer" }}
                              />
                            </div>
                            <Typography
                              className={classes.dragDropVideoText}
                              component="div"
                              variant="body1"
                              align="center"
                            >
                              {false
                                ? "uploading"
                                : "Upload a file"}
                            </Typography>
                            <input
                              id="myInput"
                              type="file"
                              ref={(ref) => (this.upload = ref)}
                              onChange={(event: any) => {
                                handleFileChange(event);
                              }}
                              style={{ display: "none" }}
                            />
                          </Grid>
                        </div>
                      </Grid>
                    </DropZone>
                  )}
                    </>
                    );
                  }}
                </MyPATUploader>
              <Typography color="primary">
              <a onClick={this.handleDownloadClick} style={{cursor: 'pointer'}}>
                    <img
                      alt="Download"
                      src="/assets/svg/learn/downloadIcon.svg"
                    />{" "}
                    Download Sample Format
              </a>
              </Typography>
            </Grid>
          </Grid>
          </Grid>

        </MyPATDialog>
      {/* <Grid className={classes.noBorder}> */}
        <MyPATDialog
              dialogOpen={openConfirmationPopup}
              dialogHasActions={true}
              // dialogHeading={
              //   <>
              //   <Grid className={classes.noBorder}>
              //     <h3 className={classes.bulkTitle}>
              //       {" "}
              //       Import Scheduled tests
              //     </h3>
              //     <MyPATIconButton buttonVariant="flat" onClick={this.handlePreviewDialogClose.bind(this)}>
							// 		<CloseIcon />
							// 	</MyPATIconButton>
              //   </Grid>
              //   </>
              // }
              isAlignCenter={true}
              customButtonVariant="withoutBorderCloseIcon"
              onDialogClose={() => this.closeConfirmationDialog()}
              isCustomBackground={false}
              isborderDialogAction={true}
              otherDialogProps={{
                fullWidth: false,
              }}
              customDialogActions={
                <>
                <Grid container justify="center" style={{paddingBottom: '30px'}}>
                  <Grid item>
                  <Button color="primary" onClick={() => this.closeConfirmationDialog()} >
                    No
                  </Button>
                  <Button variant="contained" color="primary" onClick={() => this.bulkImportProcess()}
                  >Yes</Button>
                  </Grid>

                </Grid>
                <br />

                </>
              }
            >
              <Grid className={classes.buttonCloseCont}>
              <MyPATIconButton className={classes.buttonClose} buttonVariant="flat" onClick={() => this.closeConfirmationDialog()}>
                  <CloseIcon classes={{ root: classes.iconRoot }} />
							</MyPATIconButton>
                
              </Grid>
              <Grid container justify="center" style={{textAlign: 'center'}}>
                <Grid item>
                  <img src="/assets/svg/Import-scheduled-icon.svg"/> 
                  <h3>Import Scheduled Test</h3>
                  <Typography>
                    Are you sure, you want to import {selectedTest.length} tests in {payload.destinationSkus.length > 0 ? payload.destinationSkus.length : selectedCourse.length} courses?
                  </Typography>
             

                </Grid>
              </Grid>
            </MyPATDialog>
          {/* </Grid> */}
      </>
    );
  }
}

const mapStateToProps = (state: any) => ({
  courseList: state.clientManagement.usersManagement.courseList,
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      getCourseList,
      setBulkImportTest,
      fetchExistingScheduledTests:
        courseManagementActions.fetchExistingScheduledTests,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(styles)(BulkImportTest));
